export function updateGenericDataBox2(genericData) {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_GENERIC_DATA_BOX_2',
      genericData,
    })
  }
}
